import { EnumValues } from '@card-software/library';

export enum ProductDevelopmentStatus {
  Draft = 0,
  InDevelopment = 1,
  UnderReview = 2,
  Approved = 3,
  ReadyForProduction = 4,
  Inactive = 98,
  Rejected = 99,
}

export const VALID_STATUS_TRANSITIONS: Record<number, number[]> = {
  [ProductDevelopmentStatus.Draft]: [
    ProductDevelopmentStatus.InDevelopment,
    ProductDevelopmentStatus.Inactive,
    ProductDevelopmentStatus.Rejected,
  ],
  [ProductDevelopmentStatus.InDevelopment]: [
    ProductDevelopmentStatus.UnderReview,
    ProductDevelopmentStatus.Inactive,
    ProductDevelopmentStatus.Rejected,
  ],
  [ProductDevelopmentStatus.UnderReview]: [
    ProductDevelopmentStatus.Approved,
    ProductDevelopmentStatus.Inactive,
    ProductDevelopmentStatus.Rejected,
  ],
  [ProductDevelopmentStatus.Approved]: [
    ProductDevelopmentStatus.ReadyForProduction,
    ProductDevelopmentStatus.Inactive,
    ProductDevelopmentStatus.Rejected,
  ],
  [ProductDevelopmentStatus.ReadyForProduction]: [ProductDevelopmentStatus.Inactive],
  [ProductDevelopmentStatus.Inactive]: [ProductDevelopmentStatus.InDevelopment],
  [ProductDevelopmentStatus.Rejected]: [ProductDevelopmentStatus.InDevelopment],
};

export function getValidStatusOptions(currentStatus: number, allStatuses: EnumValues): EnumValues {
  const validNextStatuses = VALID_STATUS_TRANSITIONS[currentStatus] ?? [];
  const options: EnumValues = {};

  // Always include current status
  if (allStatuses[currentStatus]) {
    options[currentStatus] = allStatuses[currentStatus];
  }

  // Add valid next statuses
  for (const status of validNextStatuses) {
    if (allStatuses[status]) {
      options[status] = allStatuses[status];
    }
  }

  return options;
}
